module.exports = __webpack_public_path__ + "static/img/fun2win-logo.d546651.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fun2win/imgs/fun2win-logo.png
// module id = 2154
// module chunks = 0